export default class AppViewModel {
  apiVersion = 'v1.0.0';
  mainNavRoutes = [
    {name: 'Home', title: 'Inicio', icon: 'home'},

    {title: 'Datos', icon: 'text_snippet',
      children: [
        {name: 'Table', title: 'Tablas interactivas', icon: 'table_chart',
          roles: {
            // and: ['aa', 'bbx'],
            or: ['aa', 'bbx'],
          },
        },
        {name: 'Charts', title: 'Gráficos', icon: 'query_stats'},
        {name: 'List', title: 'Listas', icon: 'view_list'},
        {name: 'Map', title: 'Mapas', icon: 'map'},
        {name: 'Tree', title: 'Tree', icon: 'account_tree'},
        {name: 'Calendar', title: 'Calendar', icon: 'calendar_month'},
      ]},

    {title: 'Formularios', icon: 'list_alt', children: [
      {name: 'FormsGenerator', title: 'Generador', icon: 'bolt'},
      {name: 'FormComponents', title: 'Componentes', icon: 'check_box_outline_blank'},
      {name: 'Vuelidate', title: 'Validación', icon: 'check_box'},
      {name: 'Buttons', title: 'Botones', icon: 'ads_click'},
      {name: 'DownloadExcel', title: 'Descargar excel', icon: 'download'},
    ]},

    {title: 'Layout', icon: 'space_dashboard', children: [
      {name: 'SmartContent', title: 'SmartContent', icon: 'smart_screen'},
      {name: 'NotFound', title: 'TheBreadcrumbs', icon: 'link'},
      {name: 'NotFound', title: 'TheMainNav', icon: 'menu'},
      {name: 'ProjectInfo', title: 'TheProjectInfo', icon: 'info'},
      {name: 'NotFound', title: 'TheUserMenu', icon: 'account_circle'},
    ]},

    {title: 'Continentes', icon: 'view_comfy_alt', children: [
      {name: 'Cards', title: 'Cards', icon: 'view_agenda'},
      {name: 'Collapse', title: 'Collapses', icon: 'keyboard_arrow_right'},
      {name: 'Drop', title: 'Drop', icon: 'ballot'},
      {name: 'Menu', title: 'Menus', icon: 'drag_handle'},
      {name: 'Panel', title: 'Panels', icon: 'ballot'},
      {name: 'Tabs', title: 'Tabs', icon: 'font_download'},
      {name: 'Tutorial', title: 'Tutorial', icon: 'contact_support'},
    ]},

    {title: 'Páginas estáticas', icon: 'domain_verification', children: [
      {name: 'NotFound', title: '404', icon: 'info'},
      {name: 'Unauthorized', title: 'No autorizado', icon: 'no_encryption'},
    ]},

    {title: 'Otros', icon: 'more_horiz', children: [
      {name: 'Toast', title: 'Messages/Toast', icon: 'chat_bubble_outline'},
      {name: 'QR', title: 'Generador de QR', icon: 'qr_code_2'},
      {name: 'Misc', title: 'Miscellaneous', icon: 'dashboard'},
      {name: 'Screenshot', title: 'Screenshot', icon: 'add_a_photo'},
      {name: 'Sortable', title: 'Sortable', icon: 'low_priority'},
    ]},
  ];
  theUserMenuDropList = [
    {
      label: 'Edición',
      icon: 'pi pi-pencil',
      command: () => console.log('Edit clicked!'),
    },
    {
      label: 'Visualización',
      icon: 'pi pi-eye',
      command: () => console.log('Show clicked!'),
    },
    {
      label: 'Herramientas',
      icon: 'pi pi-cog',
      command: () => console.log('Tools clicked'),
    },
  ];
}
